module.exports = __webpack_public_path__ + "img/header-diamondJewelryColliers.3862cd1.webp";